import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="school, building" maskId="round-filled-radius-0-stroke-1.5-IconSchool"><path fillRule="evenodd" clipRule="evenodd" d="M6 4.75C6 4.33579 6.33579 4 6.75 4H17.25C17.6642 4 18 4.33579 18 4.75V18.5H19V8H21.25C21.6642 8 22 8.33579 22 8.75V18.5H22.25C22.6642 18.5 23 18.8358 23 19.25C23 19.6642 22.6642 20 22.25 20H1.75C1.33579 20 1 19.6642 1 19.25C1 18.8358 1.33579 18.5 1.75 18.5H2V8.75C2 8.33579 2.33579 8 2.75 8H5V18.5H6V4.75ZM14 18.5V15H10V18.5H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
